import React from "react"
import {Button, Card, Table, Tooltip, Badge} from "antd"
import CreationDrawer from "./create/CreationDrawer";
import CreationGroupDrawer from "./create/CreationGroupDrawer";
import connect from "react-redux/es/connect/connect";
import * as SelectionActions from "../reducers/selection_builder";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types";
import SelectionBuilderTable from "./SelectionRowBuilderTable"
import UpdateGroupDrawer from "./update/SelectionGroupDrawerUpdate"

class Selection extends React.Component {
    static propTypes = {
        selection: PropTypes.array.isRequired,
        getRowUpdateSelection: PropTypes.array.isRequired,
        deActivateSelections: PropTypes.array.isRequired,
        getSelections: PropTypes.array.isRequired,
        loadSelectionsAfter: PropTypes.array.isRequired,
        selectionLoader: PropTypes.bool.isRequired,
        updateSelection: PropTypes.func.isRequired
    };

    state = {
        showCreationDrawer: false,
        showCreationGroupDrawer: false,
        showUpdateGroupDrawer: false,
        showUpdateGroupRowDrawer: false,
        showEditModal: false,
        record: null,
        subRecord: null
    };

    constructor(props) {
        super(props);
        const {match, getSelections} = this.props;
        const urlId = match.params.id;
        getSelections(urlId);
    }

    handleGroupSelection = (e, record) => {
        e.preventDefault();
        const {match} = this.props;
        const urlId = match.params.id;
        this.props.history.push(`/selection/builder/${urlId}/${record.id}/group`)
        this.setState(state => ({showCreationGroupDrawer: !state.showCreationGroupDrawer}));
    };


    handleGroupUpdateSelection = (e, r) => {
        e.preventDefault();
        const {match} = this.props;
        const urlId = match.params.id;
        this.props.history.push(`/selection/builder/${urlId}/update`)
        this.setState(state => ({showUpdateGroupDrawer: !state.showUpdateGroupDrawer, record: r.id}));

    };

    createSelectionGroup = () => {
        this.setState(state => ({showCreationDrawer: !state.showCreationDrawer}));
        const {match} = this.props;
        const urlId = match.params.id;
        this.props.history.push(`/selection/builder/${urlId}/createSelection`)
    };

    editOnClick = (record, recordItem) => {
        this.setState(state => ({toggleUpdateRowDrawer: !state.toggleUpdateRowDrawer, subRecord: record.row_id, record: recordItem.id}));
    };



    toggleCreationGroupDrawer = () => this.setState(state => ({showCreationGroupDrawer: !state.showCreationGroupDrawer}));
    toggleCreationDrawer = () => this.setState(state => ({showCreationDrawer: !state.showCreationDrawer}));
    toggleUpdateDrawer = () => this.setState(state => ({showUpdateGroupDrawer: !state.showUpdateGroupDrawer}));


    expandedRowRender = (record) => {
        return <SelectionBuilderTable isAdmin={this.props.isAdmin} pagination={false} size="small" recordItem={record} selection={this.props.selection} onEdit={this.editOnClick}/>
    };

    render() {
        const {showCreationDrawer, showCreationGroupDrawer, showUpdateGroupDrawer, record} = this.state;
        const {selection, selectionLoader, isAdmin} = this.props;
        const toEdit = selection.selectionDetails.groups.filter(x => x.id === record)[0] || {};

        if (selectionLoader || !selection) return <span>Loading</span>;

        const columns = [
            {title: 'Active', dataIndex: 'active', render: active => <Badge status={active ? 'success' : 'default'}/>},
            {title: 'Name', dataIndex: 'name'},
            {title: 'Total Number of Persons', dataIndex: 'personsInGroup'},
            {title: 'Total Number of Sites', dataIndex: 'sitesInGroup'},
            {
                title: '', render: (record) => <div className="crud-options">
                    <Button disabled={!isAdmin} icon="plus" size="small" shape="circle"
                            onClick={e => this.handleGroupSelection(e, record)}/>
                    <Button disabled={!isAdmin} icon="edit" size="small" shape="circle"
                            onClick={e => this.handleGroupUpdateSelection(e, record)}/>
                </div>
            }
        ];
        return <Card title={selection.selectionDetails.name}
                     extra={
                         <Tooltip title={'Create a new group for ' + selection.selectionDetails.name}>
                             <Button disabled={!isAdmin} type="primary" icon="plus" size="medium" shape="circle"
                                     onClick={this.createSelectionGroup}/>
                         </Tooltip>
                     }>
            <Table dataSource={selection.selectionDetails.groups} columns={columns}
                   expandedRowRender={this.expandedRowRender} loading={selectionLoader}
                   defaultExpandAllRows={false}/>
            <CreationDrawer visible={showCreationDrawer} toggleVisibility={this.toggleCreationDrawer}/>
            <UpdateGroupDrawer visible={showUpdateGroupDrawer} toEdit={toEdit} toggleVisibility={this.toggleUpdateDrawer}/>




            <CreationGroupDrawer visible={showCreationGroupDrawer} populate={selection.selectionGroupCreationData}
                                 toggleVisibility={this.toggleCreationGroupDrawer}/>

        </Card>
    }
}

const mapStateToProps = state => ({
    selection: state.selection_builder.selection,
    selectionLoader: state.selection_builder.selectionLoader,
    deActivateSelections: state.selection_builder.deActivateSelections,
    selectionRowUpdate: state.selection_builder.selectionRowUpdate,
    isAdmin: state.auth.isAdmin

});

const mapDispatchToProps = dispatch => ({
    getSelections: bindActionCreators(SelectionActions, dispatch).getSelections,
    deActivateSelections: bindActionCreators(SelectionActions, dispatch).deactivateSelection,
    updateSelection: bindActionCreators(SelectionActions, dispatch).updateGroupSelections,
    getGroupSelection: bindActionCreators(SelectionActions, dispatch).updateGroupSelections,
    getRowUpdateSelection: bindActionCreators(SelectionActions, dispatch).updateRowSelections,
});


export default connect(mapStateToProps, mapDispatchToProps)(Selection)




// WEBPACK FOOTER //
// ./src/js/selection/Selection.js